export interface ShipmentFilesOpenContext {
  tracking: string;
  record: any;
}

export interface ShipmentFilesController {
  open: (context: ShipmentFilesOpenContext) => void;
  updateRecord: (record: any) => void;
  reset: () => void;
}

declare global {
  interface Window {
    ShipmentFilesController?: ShipmentFilesController;
    tracker?: any;
  }
}

export function registerShipmentFilesController(controller: ShipmentFilesController): void {
  window.ShipmentFilesController = controller;
}